import React, { useState } from 'react';

export default function ServiceSummaryDescription({ value, canEdit, onSave }) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const description = String(value ?? '');

  const startEditing = () => {
    setDraft(description);
    setError('');
    setEditing(true);
  };
  const save = async () => {
    if (saving || !canEdit) return;
    setSaving(true);
    setError('');
    try {
      await onSave(draft);
      setEditing(false);
    } catch (failure) {
      setError(failure.response?.data?.message
        || Object.values(failure.response?.data?.errors || {}).flat().join(' ')
        || failure.message || 'Açıklama kaydedilemedi. Tekrar deneyin.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <section className="sd-summary-description" aria-labelledby="sd-summary-description-title" aria-busy={saving}>
      <div className="sd-section-heading">
        <h3 id="sd-summary-description-title"><i className="fa fa-file-text-o" aria-hidden="true" /> Servis açıklaması</h3>
        {!editing && canEdit && <button type="button" className="sd-open-tab-button"
          aria-label="Servis açıklamasını düzenle" onClick={startEditing}>
          <i className="fa fa-pencil" aria-hidden="true" /> Düzenle
        </button>}
      </div>
      {editing ? (
        <div className="sd-summary-description-editor">
          <textarea className="form-control" aria-label="Servis açıklaması"
            autoFocus value={draft} disabled={saving || !canEdit}
            onChange={event => setDraft(event.target.value)}
            onKeyDown={event => {
              if (event.key === 'Escape' && !saving) setEditing(false);
            }} placeholder="Servis açıklamasını yazın..." />
          {error && <div className="sd-summary-select-error" role="alert">{error}</div>}
          <div className="sd-summary-description-actions">
            <button type="button" className="sd-open-tab-button" disabled={saving} onClick={() => setEditing(false)}>Vazgeç</button>
            <button type="button" className="sd-open-tab-button sd-summary-description-save" disabled={saving || !canEdit} onClick={save}>
              <i className={`fa ${saving ? 'fa-circle-o-notch fa-spin' : 'fa-check'}`} aria-hidden="true" />
              {saving ? 'Kaydediliyor...' : 'Açıklamayı kaydet'}
            </button>
          </div>
        </div>
      ) : (
        <div className={`sd-summary-description-content${description.trim() ? '' : ' empty'}`}
          role="region" aria-label="Servis açıklaması metni" tabIndex={description.trim() ? 0 : undefined}>
          {description.trim() ? description : 'Servis açıklaması eklenmemiş.'}
        </div>
      )}
    </section>
  );
}
